const actions = {
  CHECK_AUTHORIZATION: "CHECK_AUTHORIZATION",
  LOGOUT: "LOGOUT",
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_ERROR: "LOGIN_ERROR",
  REGISTER_REQUEST: "REGISTER_REQUEST",
  REGISTER_SUCCESS: "REGISTER_SUCCESS",
  REGISTER_ERROR: "REGISTER_ERROR",
  USER_SURVEY_STATUS_REQUEST: "USER_SURVEY_STATUS_REQUEST",
  USER_SURVEY_STATUS_SUCCESS: "USER_SURVEY_STATUS_SUCCESS",

  editQuiz: (value, userId) => {
    return (dispatch) => {
      dispatch({
        type: actions.USER_SURVEY_STATUS_REQUEST,
        value,
        userId,
      });
    };
  },

  checkAuthorization: () => ({ type: actions.CHECK_AUTHORIZATION }),

  login: (user) => ({
    type: actions.LOGIN_REQUEST,
    payload: { user },
  }),

  logout: () => ({
    type: actions.LOGOUT,
  }),

  register: (user) => ({
    type: actions.REGISTER_REQUEST,
    user: user,
  }),
};
export default actions;
